$(document).ready(function () {
    var updateDatepicker = function () {
        $('.datepicker').each(function () {
            var elem = $(this);
            elem.datepicker(
                {format: 'dd.mm.yyyy', autoclose: true, language: 'ru'}
            );
        });
    };
    initYiiGrid('tasks-grid', {
            ajaxUpdate: ["tasks-grid"],
            ajaxVar: "ajax",
            ajaxType: "POST", enableHistory: false,
            filterClass: "filters",
            filterSelector: "{filter}",
            loadingClass: "grid-view-loading",
            pageVar: "ProjectsTasks_page",
            pagerClass: "pager",
            selectableRows: 1,
            tableClass: "table table-bordered table-striped sr-tasks-table",
            updateSelector: "{page}, {sort}",
            afterAjaxUpdate: updateDatepicker,
            csrfTokenName: typeof csrfTokenName !== undefined ? csrfTokenName : '',
            csrfToken: token,
        }
    )
    initYiiGrid('projectstasks-grid', {
            ajaxUpdate: ["projectstasks-grid"],
            ajaxVar: "ajax",
            ajaxType: "POST",
            enableHistory: false,
            filterClass: "filters",
            filterSelector: "{filter}",
            loadingClass: "grid-view-loading",
            pageVar: "ProjectsTasks_page",
            pagerClass: "pager",
            selectableRows: 1,
            tableClass: "tasks-small table table-bordered table-striped sr-ftasks-table",
            updateSelector: "{page}, {sort}",
            afterAjaxUpdate: updateDatepicker,
            csrfTokenName: typeof csrfTokenName !== undefined ? csrfTokenName : '',
            csrfToken: token,
        }
    )

    function viewWarningAlert(message) {
        $.smallBox({
            title: translate.payment_caption,
            content: message,
            color: "#C46A69",
            timeout: 20000,
            icon: "fa fa-warning shake animated"
        });
    }

    function viewSuccessAlert(message) {
        $.smallBox({
            title: translate.payment_caption,
            content: message,
            color: "#739E73",
            timeout: 8000,
            icon: "fa fa-bell swing animated"
        });
    }

    function viewInfoAlert(message) {
        $.smallBox({
            title: translate.payment_caption,
            content: message,
            color: "#C79121",
            timeout: 20000,
            icon: "fa fa-warning swing animated"
        });
    }

    function viewInfoAlertTask(message) {
        $.smallBox({
            title: translate.tasks_action_caption,
            content: message,
            color: "#C79121",
            timeout: 20000,
            icon: "fa fa-warning swing animated"
        });
    }

    function viewSuccessAlertTask(message) {
        $.smallBox({
            title: translate.tasks_action_caption,
            content: message,
            color: "#739E73",
            timeout: 8000,
            icon: "fa fa-bell swing animated"
        });
    }

    const maxMessageLength = 5000;

    $('#new-task-message').on('input', event => {
        const maxLength = maxMessageLength;
        const currentLength = event.target.value.length;
        const signsLeft = $('#message-signs-left');
        signsLeft.text(`${currentLength}/${maxLength}`);
        if (currentLength > maxLength) {
            signsLeft.addClass('exceed')
            $('#ProjectsTasksMessages-error').text(translate.taskMessageMaxLength)
            $('#ProjectsTasksMessages-submit').prop('disabled', true);
        } else {
            signsLeft.removeClass('exceed')
            $('#ProjectsTasksMessages-error').text("");
            if (currentLength > 0) {
                $('#ProjectsTasksMessages-submit').prop('disabled', false);
            } else {
                $('#ProjectsTasksMessages-submit').prop('disabled', true);
            }
        }
    })

    $('#new-task-dispute-message').on('input', event => {
        const maxLength = maxMessageLength;
        const currentLength = event.target.value.length;
        const signsLeft = $('#dispute-message-signs-left');
        signsLeft.text(`${currentLength}/${maxLength}`);
        if (currentLength > maxLength) {
            signsLeft.addClass('exceed')
            $('#ProjectsTasksDisputeMessages-error').text(translate.taskMessageMaxLength)
            $('#ProjectsTasksDisputeMessages-submit').prop('disabled', true);
        } else {
            signsLeft.removeClass('exceed')
            $('#ProjectsTasksDisputeMessages-error').text("");
            if (currentLength > 0) {
                $('#ProjectsTasksDisputeMessages-submit').prop('disabled', false);
            } else {
                $('#ProjectsTasksDisputeMessages-submit').prop('disabled', true);
            }
        }
    })

    $('#elements-content').on(
        'click', '.task-lite-edit', function (event) {
            event.preventDefault();

            var taskId = $(this).data('task');

            $.ajax(
                {
                    url: '/ajax/getWTaskEditWindow',
                    type: 'POST',
                    data: {
                        YII_CSRF_TOKEN: token,
                        taskId: taskId
                    }
                }
            )
                .done(
                    function (response) {
                        response = JSON.parse(response);
                        if (response.code == 0) {
                            $('#modal-windows').html(response.response);

                            $('#dialog').modal();
                        }
                    }
                );
        }
    );

    $('#elements-content').on('click', '.pay-work-project', function (event) {
        event.preventDefault();

        $(this).remove();
        $('.popover').hide();

        $('.pay-work').bind('click').click();
    });

    $('#elements-content').on('click', '.pay-tasks', function (event) {
        event.preventDefault();

        var holded_block = $('.holded-amount span');
        var balance_block = $('#current-balance');

        var taskList = [];
        var hold = 0;
        $('.pay-work').each(function () {
            var btn = $(this);

            if (btn.parents('tr').find('.item-check')[0].checked == true) {
                taskList.push(parseInt($(this).data('task')));
                hold += parseFloat($(this).data('amount'));
            }
        });

        if (taskList.length > 0) {
            $.ajax({
                url: '/ajax/makeMassPayment',
                type: 'POST',
                data: {YII_CSRF_TOKEN: token, task_ids: taskList}
            }).done(function (response) {
                response = JSON.parse(response);
                if (response.code == 0) {
                    viewSuccessAlert(translate.payment_in_process_message);

                    $('.pay-work').each(function () {
                        var btn = $(this);
                        var checkbox = btn.parents('tr').find('.item-check')[0];
                        if (checkbox.checked == true) {
                            btn.parents('td').html(
                                '<span class="text-success">' + translate.payment_in_process_message + '</span>'
                            );
                            checkbox.checked = false;
                        }
                    });

                    var balance = balance_block.data('amount');
                    var result = parseFloat(balance) - parseFloat(hold);
                    if (result <= 0) {
                        result = 0;
                    }
                    balance_block.text(result.formatMoney(2));

                    if ($('.holded-amount').length) {
                        var holded = holded_block.data('holded');
                        var result = parseFloat(holded) - parseFloat(hold);
                        holded_block.data('holded', result);
                        holded_block.text(result.formatMoney(2));
                    }
                } else {
                    viewInfoAlert(response.response);
                }
            });
        } else {
            viewWarningAlert(translate.payment_error_task_message);
        }

        $(this).addClass('disabled');
        $('.popover').hide();
    });

    $('#elements-content').on('click', '.pay-work', function (event) {
        event.preventDefault();

        var task_id = parseInt($(this).data('task'));
        var icon = $(this).find('i');

        const $amountToPay = $('.js-amount-to-pay'),
            $amountToPayVat = $('.js-amount-to-pay-vat'),
         $holdAmount = $('.js-hold-amount'),
            $holdAmountVat = $('.js-hold-amount-vat'),
         $currentBalance = $('.js-current-balance'),
            $currentBalanceVat = $('.js-current-balance-vat'),
            $payButton = $('.js-pay-button');

        var pay_btn = $(this);

        if (task_id > 0) {
            icon.removeClass('fa-credit-card').addClass('fa-refresh').addClass('fa-spin');

            $.ajax({
                url: '/ajax/makePayment',
                type: 'POST',
                data: {YII_CSRF_TOKEN: token, task_id: task_id}
            })
                .done(function (response) {
                    response = JSON.parse(response);
                    if (response.code == 0) {
                        viewSuccessAlert(translate.payment_success_message);
                        icon.removeClass('fa-refresh').removeClass('fa-spin').addClass('fa-credit-card');

                        var status_info = pay_btn.parents('.status-info');

                        status_info.html('<span class="text-success">' + translate.payment_success_receive_message + '</span>');

                        $currentBalance.text(response.response.balance_amount.formatMoney(2));
                        if ($currentBalanceVat.length) {
                            $currentBalanceVat.text(response.response.balance_amount_vat.formatMoney(2));
                        }

                        $amountToPay.text(response.response.amount_to_pay.formatMoney(2));
                        if ($amountToPayVat.length) {
                            $amountToPayVat.text(response.response.amount_to_pay_vat.formatMoney(2))
                        }

                        $holdAmount.text(response.response.hold_amount.formatMoney(2));
                        if ($holdAmountVat.length) {
                            $holdAmountVat.text(response.response.hold_amount_vat.formatMoney(2))
                        }
                    } else {
                        icon.removeClass('fa-refresh').removeClass('fa-spin').addClass('fa-briefcase');
                        const status_info = pay_btn.parents('.status-info');
                        status_info.html('<span class="text-success">' + translate.payment_in_process_message + '</span>');

                        if (response.code == 50) {
                            viewSuccessAlert(response.response);
                        } else {
                            viewInfoAlert(response.response);
                        }
                    }
                })
                .fail(function (response) {
                    viewWarningAlert(translate.payment_error_message);
                });
        } else {
            viewWarningAlert(translate.payment_error_task_message);
        }
    });

    function activateGroupButton(activate, block) {
        var parent = block.parents('#elements-content');

        var classNames = ['group-tasks'];
        if ($('.pay-tasks').length) {
            classNames[1] = 'pay-tasks';
        }
        if ($('.ungroup-tasks').length) {
            classNames[2] = 'ungroup-tasks';
        }
        if ($('.move-to-group-tasks').length) {
            classNames[3] = 'move-to-group-tasks';
        }

        for (i in classNames) {
            if (activate) {
                parent.find('.' + classNames[i]).removeClass('disabled');
            } else {
                parent.find('.' + classNames[i]).addClass('disabled');
            }
        }

        var tasks = [];
        $.each(parent.find('input[class="item-check"]:checked'), function () {
            tasks.push($(this).data('task'));
        });
        $.each(parent.find('input[class="item-check ungroup-check"]:checked'), function () {
            tasks.push($(this).data('task'));
        });
        tasks = tasks.join(';', tasks);

        parent.find('.tasks_ids_list').val(tasks);
    }

    //Включение и выключение кнопки вызова модального окна с кнопками изменения статуса
    function activateChangeStatusButton(activate, block) {
        var parent = block.parents('#elements-content');

        var classNames = '.change-status-tasks';

        if (activate) {
            parent.find(classNames).removeClass('disabled');
        } else {
            parent.find(classNames).addClass('disabled');
        }


        var tasks = [];
        $.each(parent.find('input[class="item-check"]:checked'), function () {
            tasks.push($(this).data('task'));
        });
        $.each(parent.find('input[class="item-check ungroup-check"]:checked'), function () {
            tasks.push($(this).data('task'));
        });
        tasks = tasks.join(';', tasks);

        parent.find('.tasks_ids_list').val(tasks);

        $('.modal-body.change-status-tasks').html('');
        if (tasks) {
            $.ajax('/ajax/getStatusTasksList', {
                method: 'POST',
                data: {'tasksIdsList': tasks, YII_CSRF_TOKEN: token}
            }).done(function (response) {
                response = JSON.parse(response);
                if (response.code == 0) {
                    $('.modal-body.change-status-tasks').prepend(response.response);
                } else {
                    // viewInfoAlertTask(response.response);
                    parent.find(classNames).addClass('disabled');
                }
            }).fail(function (response) {
                viewInfoAlertTask(response.response);
                parent.find(classNames).addClass('disabled');
            });
        }
    }

    $('#elements-main').on('click', '.all-check', function () {
        var block = $(this).parents('table');
        var state = $(this).is(':checked');

        if (state) {
            block.find('.item-check').prop('checked', true);
        } else {
            block.find('.item-check').prop('checked', false);
        }

        activateGroupButton(state, block);
        activateChangeStatusButton(state, block);
    });

    $('#elements-main').on('click', '.item-check', function () {
        var block = $(this).parents('table');

        block.find('.all-check').prop('checked', false);

        if (block.find('.item-check').is(':checked')) {
            activateGroupButton(true, block);
            activateChangeStatusButton(true, block);
        } else {
            activateGroupButton(false, block);
            activateChangeStatusButton(false, block);
        }
    });

    $('.save-group').click(function (event) {
        event.preventDefault();

        var title = $('#group-title').val();

        function format(d) {
            return '<div class="radio user-group-item">' +
                '<label>' +
                '<input type="radio" name="UserGroups[id]" checked="checked" value="' + d.group_id + '" class="radio style-0">' +
                '<span>' + d.title + '</span>' +
                '</label>' +
                '</div>';
        }

        $.ajax({
            url: '/ajax/saveUserGroup',
            type: 'POST',
            data: {YII_CSRF_TOKEN: token, title: title}
        })
            .done(function (response) {
                response = JSON.parse(response);
                if (response.code == 0) {
                    $('.groups').prepend(format(response.response));
                } else {
                    $('.group-create-error').text(translate.error_valid_massage);
                }
            });
    });

    $('.add-group').click(function (event) {
        event.preventDefault();

        var title = $('#group-title').val();

        $.ajax({
            url: '/ajax/saveUserGroup',
            type: 'POST',
            data: {YII_CSRF_TOKEN: token, title: title}
        })
            .done(function (response) {
                response = JSON.parse(response);
                if (response.code == 0) {
                    location.reload();
                } else {
                    $('.group-create-error').text(translate.error_valid_massage);
                }
            });
    });

    $('.ungroup-all-tasks').on('click', function (e) {
        var id = $(this).data('id');
        $.ajax("/ajax/ungroupAllTaskByGroup", {
            method: "POST",
            data: {groupId: id, YII_CSRF_TOKEN: token}
        }).done(function (response) {
            response = JSON.parse(response);
            if (response.code) {
                viewInfoAlertTask(response.response);
            } else {
                viewSuccessAlertTask(response.response);
            }

        });
    });

    $('.group-delete').on('click', function (e) {
        var id = $(this).data('id'),
            parentTr = $(this).closest("tr");

        $.ajax("/ajax/deleteGroup", {
            method: "POST",
            data: {groupId: id, YII_CSRF_TOKEN: token}
        }).done(function (response) {
            response = JSON.parse(response);
            if (parentTr.length) {
                $(parentTr.eq(0)).remove();
            }

            if (response.code) {
                viewInfoAlertTask(response.response);
            } else {
                viewSuccessAlertTask(response.response);
            }
        });
    });

    $('body').on('click', '.check-action', function (event) {
        event.preventDefault();
        var that = $(this);

        $.SmartMessageBox({
            title: translate.task_action_caption,
            content: translate.task_action_message,
            buttons: '[' + translate.button_no + '][' + translate.button_yes + ']'
        }, function (ButtonPressed) {
            if (ButtonPressed === translate.button_yes) {
                window.location = that.prop('href');
            }
        });
    });

    $('#task-table-actions-button').on('click', function (e) {
      const listEl = $('#task-table-actions-list');
      const openClass = 'open';
      if (listEl && listEl[0]) {
        if (listEl[0].classList && listEl[0].classList.contains(openClass)) {
            listEl[0].classList.remove(openClass);
        } else {
            listEl[0].classList.add(openClass);
        }
      }
    });

    $('#export-tasks-xls').on('click', function (e) {
        e.preventDefault();

        var inputs = $('.filters input, .filters select');
        var form = $('#exportTasks');

        $.each(inputs, function (index, value) {
            var el = $(value).clone().css('display', 'none');
            form.append(el);
        });

        form.submit();
    });

    $('#elements-content').on(
        'keyup', '#ProjectsTasks_price', function () {
            checkCommission();
        }
    );
    const checkCommission = () => {
        var price = $('#ProjectsTasks_price').val();
        var worker_id = $('input[name="ProjectsTasks[worker_id]"]').val();
        var checkBoxInsurance = $('#ProjectsTasks_insurance_status_id') && $('#ProjectsTasks_insurance_status_id').prop('value') ? 1 : 0;
        var sub_category_id = $('#ProjectsTasks_subCategory').val();
        var isNew = $('#edit-task-form').attr('is-new') === 'true';
        if (price && !isNew)
            $.ajax(
                {
                    url: '/ajax/get-price-with-commission',
                    type: 'POST',
                    data: {
                        YII_CSRF_TOKEN: token,
                        price: price,
                        worker_id: worker_id,
                        need_insurance: checkBoxInsurance,
                        sub_category_id: sub_category_id
                    }
                }
            )
                .done(
                    function (response) {
                        response = JSON.parse(response);
                        if (response.code == 0 && response.response) {
                            $('.with-commission').text(response.response.total);
                            $('.commission-fee-amount').text(response.response.commission);
                            $('.insurance-cost-in-currency').text(response.response.insurance);
                            if (checkBoxInsurance) {
                                $('.task-damage-compensation').css('display', 'inline-flex');
                            } else {
                                $('.task-damage-compensation').css('display', 'none');
                            }
                        } else {
                            $('.task-damage-compensation').css('display', 'none');
                        }
                    }
                );
    };

    $('body').on('show.bs.modal', '#moveToGroups, #ungroupTasks', function () {
        var _this = $(this);
        _this.find('input[name="UserGroups[id]"]').prop('disabled', true);
        $.each($('#elements-content input[class="item-check"]:checked'), function () {
            var taskId = $(this).data('task'),
                groups = String($(this).data('groups'));
            groups.split(',').forEach(function (s) {
                var checkBoxLabel = _this.find('[data-id="label-group-' + s + '"]');
                _this.find('input[name="UserGroups[id]"][value="' + s + '"]').prop('disabled', false);
                if (checkBoxLabel.length) {
                    checkBoxLabel.attr('title', checkBoxLabel.attr('title') + ' ' + taskId + ',');
                }
            });
        });
    });

    $('.task-reject-link').click(function () {
        var link = $(this).data('link');
        $.SmartMessageBox({
            title: translate.task_rejection_caption,
            content: translate.task_rejection_message,
            buttons: '[' + translate.button_no + '][' + translate.button_yes + ']'
        }, function (ButtonPressed) {
            if (ButtonPressed === translate.button_yes) {
                if (link) {
                    location.href = link;
                }
            }
        });
    });

    $('#ProjectsTasksMessages-submit').click((e) => {
        const taskIdAttr = e.target.attributes.getNamedItem('data-task-id');
        const taskId = taskIdAttr? taskIdAttr.value : '0';
        const userIdEl = document.getElementById('userId');
        const userId = userIdEl ? userIdEl.content : '0';
        try {
            window.dataLayer.push({ event: 'tasks_task_clicks', task_num: taskId, click_id: 'send', user_id: userId });
        } catch (_) {}
    });

    const setCurPageFilter = () => {
        let curFilterElement = null;
        switch (location.pathname) {
            case '/ftasks':
            case '/ftasks/list':
                curFilterElement = $('#task-status-filter-all');
                break;
            case '/ftasks/forAcceptance':
                curFilterElement = $('#task-status-filter-acceptance');
                break;
            case '/ftasks/forPay':
                curFilterElement = $('#task-status-filter-pay');
                break;
            default:
                break;
        }
        if (!!curFilterElement && !!curFilterElement[0]) {
            curFilterElement[0].classList.add('active');
        }
    }

    checkCommission();
    setCurPageFilter();
});
